import {tdProps, thProps, cardTitleProps} from '../../common';

export const coursePrize = {
	title: {
		text: {children: '종목별 시상안내', ...cardTitleProps},
	},
	table: {
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '부별'},
			{...thProps, children: '시상내역'},
		],
		trs: [
			// [
			// 	{...tdProps, children: '풀코스 부문'},
			// 	{...tdProps, children: '남자/여자'},
			// 	{
			// 		...tdProps,
			// 		children:
			// 			'1-3위: 상품권, 상장, 트로피  /  4-5위: 상장,트로피, 부상/ 6- 15위 : 상장, 부상',
			// 	},
			// ],
			[
				{...tdProps, children: '하프코스 부문', rowSpan: '5'},
				{...tdProps, children: '남자/여자', rowSpan: '5'},
				{
					...tdProps,
					children:
						'1위: 30만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'2위: 20만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'3위: 15만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'4위: 10만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'5위: 5만원, 상장, 트로피',
				},
			],
			[
				{...tdProps, children: '10km코스 부문', rowSpan: '5'},
				{...tdProps, children: '남자/여자', rowSpan: '5'},
				{
					...tdProps,
					children:
						'1위: 20만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						' 2위: 15만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'3위: 10만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'4위: 7만원, 상장, 트로피',
				},
			],
			[
				{
					...tdProps,
					children:
						'5위: 5만원, 상장, 트로피',
				},
			],
		],
		descriptions: [
			{
				content: {
					children: `정해진 종목별 출발시간 이전에 출발하거나 10분이 지난 후 출발하는 분들은 시상에서 제외됩니다.`,
				},
			},
			{
				content: {
					children: `엘리트선수는 선수해지 2년이 지난 후 입상 가능합니다.`,
				},
			},
			{
				content: {
					children: `주최 측 사정에 의해 일정이 변경될 수 있으며 일정 인원 미달시 시상내역이 변경될 수 있습니다.`,
				},
			},
			{
				content: {
					children: `대회 당일 시상식이 진행되며, 시상식 미참석하신 분은 요청시 시상품이 택배비 본인 부담으로 배송됩니다.`,
				},
			},
			{
				content: {
					children: `입상 가능성이 있는 참가자께서는 시상 시 본인 확인을 위해 신분증(모바일 신분증 가능)을 반드시 지참해 주시기 바랍니다.`,
				},
			},
			{
				content: {
					children: `시상금은 세액공제 후 대회종료 3주이내 입금됩니다. (대회종료 후 상금 입금안내 문자보냄)`,
				},
			},
			{
				content: {
					children: `대회 마감 이후 종목변경 / 제한시간 이후 완주자는 시상에서 제외됩니다.`,
				},
			},
		],
	},
};

export const prizeInfo = {
	title: {
		text: {children: '시상금 안내', ...cardTitleProps},
	},
	table: {
		ths: [
			{...thProps, children: '종목'},
			{...thProps, children: '순위'},
			{...thProps, children: '시상'},
		],
		trs: [
			[
				{...tdProps, children: '하프코스 부문\n(남/여)', rowSpan: '5'},
				{...tdProps, children: '1위'},
				{...tdProps, children: '상품권(20만원), 상장, 트로피'},
				{
					...tdProps,
					children: ``,
					rowSpan: '5',
				},
			],
			[
				{...tdProps, children: '2위'},
				{...tdProps, children: '상품권(15만원), 상장, 트로피'},
			],
			[
				{...tdProps, children: '3위'},
				{...tdProps, children: '상품권(10만원), 상장, 트로피'},
			],
			[
				{...tdProps, children: '4-5위'},
				{...tdProps, children: '상장, 트로피, 부상'},
			],
			[
				{...tdProps, children: '6-15위'},
				{...tdProps, children: '상장, 부상'},
			],
			[
				{...tdProps, children: '10km코스 부문\n (남/여)', rowSpan: '5'},
				{...tdProps, children: '1위'},
				{...tdProps, children: '상품권(10만원), 상장, 트로피'},
				{
					...tdProps,
					children: ``,
					rowSpan: '5',
				},
			],
			[
				{...tdProps, children: '2위'},
				{...tdProps, children: '상품권(7만원), 상장, 트로피'},
			],
			[
				{...tdProps, children: '3위'},
				{...tdProps, children: '상품권(5만원), 상장, 트로피'},
			],
			[
				{...tdProps, children: '4-5위'},
				{...tdProps, children: '상장, 트로피, 부상'},
			],
			[
				{...tdProps, children: '6-15위'},
				{...tdProps, children: '상장, 부상'},
			],

			[
				{...tdProps, children: '단체부스'},
				{...tdProps, children: '단체 총 참가자\n30명 이상'},
				{...tdProps, children: '부스 1동 제공'},
				{...tdProps, children: ''},
			],
			[
				{...tdProps, children: '경품 증정'},
				{
					...tdProps,
					children: '사전 추첨(행사장에서 확인)',
					colSpan: '2',
				},
			],
		],
		descriptions: [
			{
				content: {
					children: '5km 코스는 기록 미측정으로 시상에서 제외됩니다.',
				},
			},
			{
				content: {
					children:
						'남, 여 부문 종목별 참가자가 각 200명 이하일 경우 시상은 1 - 10위까지만 진행됩니다.',
				},
			},
		],
	},
};
